import { render, staticRenderFns } from "./ModificarEmpleado.vue?vue&type=template&id=0182c260&scoped=true&"
import script from "./ModificarEmpleado.vue?vue&type=script&lang=js&"
export * from "./ModificarEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0182c260",
  null
  
)

export default component.exports